// https://github.com/aws-amplify/amplify-cli/issues/2420

export const getAuditNextItems = /* GraphQL */ `
  query GetAuditNextItems($id: ID!) {
    getAudit(id: $id) {
      id
      processedItems
      nextItems {
        locationIdx
        owner
        name
      }
      updatedAt
    }
  }
`;

export const auditByStatusByDateOptions = /* GraphQL */ `
  query AuditByStatusByDate(
    $reloadYardId: ID
    $statusCreateDateTime: ModelAuditAuditByStatusByDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAuditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    auditByStatusByDate(
      reloadYardId: $reloadYardId
      statusCreateDateTime: $statusCreateDateTime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        accountName
        assignedTo
        createDateTime
      }
    }
  }
`;
